import React from 'react';
import { useTranslation } from 'react-i18next';

import type { SearchResetButtonProps } from '@uncinc/react-searchkit/dist/components/Reset';

import Button from '../index';

const SearchResetButton = (buttonProps: SearchResetButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      {...buttonProps}
      type="primary"
      variant="icon-only"
      icon="close"
      aria-label={t('components.search_general.buttons.reset_search')}
    />
  );
};

export default SearchResetButton;
